var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramNegativeN(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_750_1017)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.25 14.0566C28.25 21.7886 21.982 28.0566 14.25 28.0566C6.51801 28.0566 0.25 21.7886 0.25 14.0566C0.25 6.32465 6.51801 0.0566406 14.25 0.0566406C21.982 0.0566406 28.25 6.32465 28.25 14.0566ZM14.7517 10.3921C13.39 10.9584 10.6685 12.1307 6.5872 13.9088C5.92446 14.1724 5.57729 14.4302 5.54568 14.6823C5.49227 15.1084 6.02582 15.2762 6.75237 15.5046C6.8512 15.5357 6.9536 15.5679 7.05858 15.602C7.7734 15.8344 8.73495 16.1062 9.23482 16.117C9.68826 16.1268 10.1943 15.9399 10.7531 15.5562C14.5663 12.9821 16.5348 11.6811 16.6583 11.653C16.7455 11.6332 16.8664 11.6084 16.9482 11.6811C17.0301 11.7539 17.022 11.8917 17.0134 11.9286C16.9605 12.154 14.8661 14.1011 13.7823 15.1087C13.4444 15.4228 13.2047 15.6457 13.1557 15.6965C13.046 15.8105 12.9341 15.9184 12.8266 16.022C12.1625 16.6622 11.6646 17.1423 12.8542 17.9262C13.4259 18.3029 13.8833 18.6145 14.3397 18.9253C14.8382 19.2647 15.3353 19.6033 15.9785 20.0249C16.1424 20.1323 16.2989 20.2439 16.4514 20.3526C17.0314 20.7661 17.5525 21.1376 18.1963 21.0784C18.5704 21.044 18.9569 20.6922 19.1531 19.643C19.6169 17.1636 20.5286 11.7915 20.7392 9.57778C20.7577 9.38382 20.7345 9.1356 20.7158 9.02664C20.6972 8.91768 20.6582 8.76243 20.5166 8.6475C20.3488 8.5114 20.0899 8.4827 19.9741 8.48474C19.4475 8.49401 18.6396 8.77492 14.7517 10.3921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.84674,
    cy: 4.65338,
    r: 4.59674,
    fill: "#FF6F43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_750_1017"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.25 0.0566406)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramNegativeN);
export default __webpack_public_path__ + "static/media/telegram-negative-n.583653c4c952a61cc5f34a472057ced9.svg";
export { ForwardRef as ReactComponent };